/**
 * Converts a raw fetch/API error into a user-friendly message.
 * Raw network errors (e.g. "Failed to fetch") are replaced with an actionable hint.
 */
export function friendlyError(err: unknown): string {
  const msg = (err as { message?: string }).message ?? '';
  if (!msg || msg === 'Failed to fetch' || msg === 'Load failed') {
    return "Couldn't reach the server — check your connection and give it another shot.";
  }
  if (msg.toLowerCase().includes('failed to fetch')) {
    return 'Our data service is having a moment. Hang tight and try refreshing the page.';
  }
  return msg;
}
